import axios from '@/app/axios'
import Responses from '@/app/utils/responses'
import PaginationResponse from '@/common/pagination/entities/pagination-response'
import ActionGroup from '../models/action-group'
import ActionGroupsRequest from '@/app/requests/action-groups-request'

class ActionGroupsService {
  public async findAllAsync(projectId: string) {
    const res = await axios.post<ActionGroup[]>('actionmembership/groups', {
      projectId,
      text: '',
    })
    return Responses.list(res)
  }

  public async findAllAdminAsync(request: ActionGroupsRequest) {
    const res = await axios.post<PaginationResponse<ActionGroup>>(
      'actiongroup/find-admin',
      request
    )
    return Responses.pagedList(res)
  }

  public async createAdminAsync(group: ActionGroup) {
    const res = await axios.post<ActionGroup>(`actiongroup/create-admin`, group)
    return Responses.obj(res)
  }

  public async updateAdminAsync(group: ActionGroup) {
    const res = await axios.put<ActionGroup>('actiongroup/update-admin', group)
    return Responses.obj(res)
  }

  public async deleteAdminAsync(group: ActionGroup) {
    const res = await axios.post<ActionGroup>(
      `actiongroup/${group.id}/delete-admin`
    )
  }
}

export default new ActionGroupsService()
